import React,{useState, useEffect} from 'react'
import './style.css'
import Footer from './Footer'
import FileSaver from 'file-saver'
import axios from 'axios'
import Navbar from '../Component/Navbar'
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';

const Admin = () => {
    const [file, setFile] = useState(null);
    const [csvFileError, setCsvFileError]=useState('');
    const [currentState, setCurrentState] = useState("")
    const [cookies, removeCookie] = useCookies(['Token']);
    // console.log(`cookies Token ${cookies.Token}`)

    let navigate = useNavigate();

    useEffect(()=>{
        setCurrentState("2");
    },[])

    const types = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']

    const changeHandler = async(e) =>{
        let selected = e.target.files[0]
        console.log(selected)

        if(selected && types.includes(selected.type)){
            try{
                setFile(selected)
                setCsvFileError('')
                const formData = new FormData();
		        formData.append('studentFile', selected);
                
                const config = {
                    headers: { Authorization: "Bearer " + cookies.Token }
                };

                console.log(`Bearer ${cookies.Token}`)
                await axios.post(`https://sabre-ng-e-certificate.herokuapp.com/register`, config, formData).then((response) => {
                  if(response.status === 201){
                      console.log("Correct Email")
                      console.log(response.data)
                    }
                });
              }
              catch(error){
                 console.log('New error')
              }
        }else{
            setFile(null)
            setCsvFileError("Pls select a valid excel .xlsx file")
        }
    }

    const handleBtnClick = () =>{
        FileSaver.saveAs(
          process.env.PUBLIC_URL + "/resources/Text.csv",
          "Template.csv"); 
    }

    const clickState = (currentClickState) =>{
        // console.log(`clicked: ${currentClickState}`)
        navigate("/login", { replace: false });
        removeCookie('Token');
    }


  return (
    <div className='mainm-contain'>
        <Navbar  logoutClick={clickState} defaultState={currentState}/>
        <div className='adminContainer'>
            <div id="submitForm_">
                <span id="heading">Sabre E-Certificate Portal Admin </span>
                <div className="sub-submitForm_">
                    <input type="file" name="file" id="file" className="inputfile" onChange={changeHandler} hidden/>
                    {cookies.Token === "undefined" ? "" : <label for="file" id="submitButn">Upload Student Record</label> }
                    <div className="label-output">
                        {csvFileError && <div className="error">{csvFileError}</div>}
                        {file && <div className="filename">{file.name}</div>}
                    </div>
                    <button onClick={handleBtnClick} type="submit" id="submitButn_">Download Template</button>
                    {/* {file && <div className='progress-contain'><Progressbar newUrl={urlVal} file={file} setFile={setFile}/></div>} */}
                </div>
            </div>
        </div>
            <div className="mainfootContain">
                <Footer />
            </div>
    </div>
  )
}

export default Admin